import React from "react";
import { TooltipVariant } from "../IdlesTooltip";
import { TooltipGridCell, TooltipGridRow } from "@infobis/ui-styles-utils";
import cn from "classnames";
import st from "../IdlesTooltip.module.scss";

type IdlesTooltipHeaderProps = {
    variant: TooltipVariant
}

const RenderTooltipHeader = ({ variant }: IdlesTooltipHeaderProps) => {
    const className = cn(st[`tooltip__text--common--${variant}`], st[`tooltip__text--naming--${variant}`])

    return (
        <TooltipGridRow>
            <TooltipGridCell />
            <TooltipGridCell
                align={'end'}
                contentClassName={className}
            >
                Факт
            </TooltipGridCell>
            <TooltipGridCell
                align={'end'}
                contentClassName={className}
            >
                Норма
            </TooltipGridCell>
        </TooltipGridRow>
    )
}

export default RenderTooltipHeader;